import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import CodeInput from "shared/components/CodeInput";
import useSendCode, { showSendCodeFeedbackBanner } from "shared/hooks/useSendCode";

import "./Sms.scss";

const SmsCode = (props) => {
	const {
		isSubmitting,
		submitOTPCode,
		validationError,
		fullPhoneNumber: phoneNumber,
	} = props;

	const [code, setCode] = useState("");
	const [showCodeSentSuccess, setShowCodeSentSuccess] = useState(false);
	const { sendCode, canSendCode, isSendingCode } = useSendCode({ disableLeadingSend: true });
	const codeSentTimer = useRef();

	const handleDigitChange = (digits) => {
		const nextCode = digits.map(({ value }) => value).join("");
		setCode(nextCode);
	};

	const handleSubmitCode = (e) => {
		e.preventDefault();
		submitOTPCode(code);
	};

	const handleResendCode = () => {
		if (isSendingCode || !canSendCode) {
			return;
		}

		sendCode(phoneNumber)
			.then(() => setShowCodeSentSuccess(true))
			.catch(showSendCodeFeedbackBanner);
	};

	useEffect(() => {
		if (showCodeSentSuccess && !isSendingCode) {
			clearTimeout(codeSentTimer.current);

			codeSentTimer.current = setTimeout(() => {
				setShowCodeSentSuccess(false);
				codeSentTimer.current = null;
			}, 5000);
		}
	}, [showCodeSentSuccess, isSendingCode]);

	// clear the timer when the component unmounts
	useEffect(() => () => clearTimeout(codeSentTimer.current), []);

	return (
		<form className="oknf oknf--gray login-form login-sms">
			<div className="login-fields login-fields-code">
				<div className={classnames("login-sms-code-sent", {
					"login-sms-code-sent-hide": !showCodeSentSuccess,
				})}>
					<div className="login-sms-code-sent-success">
						<i className="login-sms-code-sent-success-icon" />
					</div>
					<Str>Code sent!</Str>
				</div>
				<CodeInput
					handleDigitChange={handleDigitChange}
					showError={validationError}
				/>
			</div>

			<div className="login-actions">
				<button
					type="submit"
					disabled={code.length < 6}
					className={classnames("login-actions-button", {
						"isSubmitting": isSubmitting,
					})}
					onClick={handleSubmitCode}
				>
					{isSubmitting ? _str("Submitting…") : _str("Next")}
				</button>
			</div>

			<div className="login-sms-existing">
				<button
					type="button"
					className={classnames("login-fields-field-link", {
						"sending": isSendingCode,
					})}
					onClick={handleResendCode}
					disabled={!canSendCode}
				>
					{isSendingCode ? _str("Sending Code") : _str("Resend Code")}
				</button>
			</div>

		</form>
	);
};

SmsCode.propTypes = {
	isSubmitting: PropTypes.bool.isRequired,
	validationError: PropTypes.bool.isRequired,
	submitOTPCode: PropTypes.func.isRequired,

	// fullPhoneNumber includes dialing code
	fullPhoneNumber: PropTypes.string.isRequired,
};

export default SmsCode;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/SmsCode.jsx